import { format } from 'date-fns/format'

export function todayDateOnly(): string {
  return format(new Date(), 'yyyy-MM-dd')
}

export function parseDateOnly(value: string): Date {
  const [year, month, day] = value.split('-').map(Number)

  return new Date(year, month - 1, day)
}

export function formatDateOnly(date: string, displayFormat: string) {
  return format(parseDateOnly(date), displayFormat)
}
